// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"C4-z","categoryName":"D4-z","categoryImage":"E4-z","categoryContent":"F4-z","bottomAligned":"G4-z"};